// services/storage.service.ts
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  IncomingMailWithAttachmentsCreate,
  User,
} from './ARCDOXservice.service'; // المسار حسب مشروعك
import { LocalStorageEnums } from '../app/Enums/LocalStorageEnums.enum';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // دوال الجلسة
  sessionIsExpired(): boolean {
    if (!this.isBrowser) return true;
    const expireDateStr = localStorage.getItem(
      LocalStorageEnums.SessionExpireDate,
    );
    if (!expireDateStr) return true;
    const expireDate = new Date(expireDateStr).getTime();
    return expireDate < Date.now();
  }

  getSessionExpireDate(): string | null {
    return this.isBrowser
      ? localStorage.getItem(LocalStorageEnums.SessionExpireDate)
      : null;
  }
  setsessionDuration(sessionDuration: any): void {
    localStorage.setItem(LocalStorageEnums.sessionDuration, sessionDuration);
  }

  setSessionExpireDate(SessionExpireDate: any): void {
    localStorage.setItem(
      LocalStorageEnums.SessionExpireDate,
      SessionExpireDate,
    );
  }

  getSessionDuration(): string | null {
    return this.isBrowser
      ? localStorage.getItem(LocalStorageEnums.sessionDuration)
      : null;
  }

  setSessionDuration(duration: string | number | undefined): void {
    if (this.isBrowser && duration) {
      localStorage.setItem(LocalStorageEnums.sessionDuration, String(duration));
    }
  }

  // دوال التوكن
  setToken(token: any): void {
    if (this.isBrowser && token) {
      localStorage.setItem(LocalStorageEnums.Token, JSON.stringify(token));
    }
  }

  getToken(): any {
    if (!this.isBrowser) return null;
    const token = localStorage.getItem(LocalStorageEnums.Token);
    return token ? JSON.parse(token) : null;
  }

  // دوال المستخدم
  setUser(user: any): void {
    if (this.isBrowser && user) {
      localStorage.setItem(LocalStorageEnums.User, JSON.stringify(user));
    }
  }

  // ========== INCOMING MAIL DRAFT ==========
  storesIncomingMailDraft(IncomingMailDraft: any): void {
    if (this.isBrowser && IncomingMailDraft) {
      localStorage.setItem(
        LocalStorageEnums.IncomingMailDraft,
        JSON.stringify(IncomingMailDraft),
      );
    }
  }

  removeIncomingMailDraft() {
    localStorage.removeItem(LocalStorageEnums.IncomingMailDraft);
  }

  getIncomingMailDraft(): any {
    if (!this.isBrowser) return null;
    const IncomingMailDraft = localStorage.getItem(LocalStorageEnums.IncomingMailDraft);
    return IncomingMailDraft ? JSON.parse(IncomingMailDraft) : null;
  }

  // ========== OUTGOING MAIL DRAFT ==========
  storeOutgoingMailDraft(outgoingMailDraft: any): void {
    if (this.isBrowser && outgoingMailDraft) {
      localStorage.setItem(
        LocalStorageEnums.OutgoingMailDraft,
        JSON.stringify(outgoingMailDraft),
      );
    }
  }

  removeOutgoingMailDraft(): void {
    if (this.isBrowser) {
      localStorage.removeItem(LocalStorageEnums.OutgoingMailDraft);
    }
  }

  getOutgoingMailDraft(): any {
    if (!this.isBrowser) return null;
    const draft = localStorage.getItem(LocalStorageEnums.OutgoingMailDraft);
    return draft ? JSON.parse(draft) : null;
  }

  getUser(): User {
    const user = localStorage.getItem(LocalStorageEnums.User);
    return User.fromJS(JSON.parse(user!));
  }

  // دوال اللغة
  setLanguage(lang: string): void {
    if (this.isBrowser && lang) {
      localStorage.setItem(LocalStorageEnums.NitcotekArcdoxLanguage, lang);
    }
  }

  getLanguage(): string | null {
    return this.isBrowser
      ? localStorage.getItem(LocalStorageEnums.NitcotekArcdoxLanguage)
      : null;
  }

  // تسجيل الخروج
  logout(): void {
    if (!this.isBrowser) return;
    localStorage.removeItem(LocalStorageEnums.User);
    localStorage.removeItem(LocalStorageEnums.Token);
    localStorage.removeItem(LocalStorageEnums.SessionExpireDate);
    localStorage.removeItem(LocalStorageEnums.sessionDuration);
    
  }
}